export default class NBAInsightEntity {
  constructor() {
    this.containerId = null;
    this.id = null;
    this.offerId = null;

    this.isImageContent = null;
    this.imageUrl = null;
    this.imageAltText = null;

    this.isTextContent = null;
    this.textHeader = null;
    this.textValue = null;
    this.textInstruction = null;
    this.textStaticUrl = null;
    this.icon = null;

    this.isAction = null;
    this.actionUrl = null;
  }
}
